import React, { Component } from 'react';

import i18n from 'i18n-react';

import { storageKeys } from 'settings';
import {
  APIHandler,
  DataHandler,
  StorageHandler,
  RetainGrid,
  ContentHeader,
  BackButton,
} from 'C4';

const getTotalProgress = (res) => {
  let totalProgress = 0;
  if (res && res.data && res.data[0]) {
    const { chapters } = res.data[0];
    chapters.forEach((chapter) => {
      totalProgress += chapter.progress;
    });
  }
  return totalProgress;
};

const getTotalPages = (res) => {
  let totalPages = 0;
  if (res && res.data && res.data[0]) {
    const { chapters } = res.data[0];
    chapters.forEach((chapter) => {
      totalPages += (chapter.total_pages - 1);
    });
  }
  return totalPages;
};

const calculateProgress = (progress, pages) =>
  Math.round((progress / pages) * 100);

export default class TrainingView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      totalprogress_value: 0,
      diploma: 0,
    };
  }

  componentWillMount() {
    this.getUserInfo();
    if (this.state.totalprogress_value >= 100) {
      this.setState({ diploma: 100 });
    }
  }

  getUserInfo() {
    StorageHandler.load(storageKeys.user).then(res => {
      if (res) {
        const { email } = res;
        DataHandler.matchAppId().then(appId => {
          DataHandler.checkKey(
            storageKeys.progress,
            APIHandler.getUserProgress(appId, email),
          ).then(userProgress => {
            const totalProgress = getTotalProgress(userProgress);
            const totalPages = getTotalPages(userProgress);
            const percentage = calculateProgress(totalProgress, totalPages);
            this.setState({ totalprogress_value: percentage });

            if (percentage >= 100) {
              this.setState({ diploma: 100 });
            } else {
              this.setState({ diploma: 0 });
            }
          });
        });
      } else {
        this.setState({ totalprogress_value: 0 });
      }
    });
  }

  render() {
    return (
      <div className='contentContainer retainView'>
        <ContentHeader
          header={i18n.translate('contentHeaders.retain')}
          subtitle={i18n.translate('pageDescriptions.retain')}
        />
        <RetainGrid />
      </div>
    );
  }
}
